import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/other_page.svg")